__turbopack_context__.v({
  "root": "style-module-scss-module__c7GYaa__root",
});
